import React, { PureComponent } from 'react';
import {
  FaFortAwesome,
  FaHistory,
  FaMobileAlt,
  FaUser,
  FaYenSign
} from 'react-icons/fa';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { firebaseConnect, getVal } from 'react-redux-firebase';
import { compose } from 'redux';
import styled from 'styled-components';

import Heading, { SubHeading } from '../../components/heading';
import Indicator from '../../components/indicator';
import formatCurrency from '../../utilities/format-currency';

const Container = styled.div`
  padding: 5em 1em;
  background: #f0f0f0;
  color: #111111;
`;

const Table = styled.table`
  max-width: 50em;
  margin: 2em auto;
  border-spacing: 0 0.5em;
  line-height: 1.6;
  th,
  td {
    padding: 0 1.5em;
    height: 4em;
  }
  th {
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-weight: normal;
    background: ${props => props.theme.primary};
    color: white;
    text-align: left;
    > *:first-child {
      margin-right: 0.8em;
      padding-top: 0.1em;
    }
  }
  td {
  }
`;

const Warning = styled.div`
  font-size: 0.7em;
`;

/*
 * Hide map temporarily for remote start
const MapContainer = styled.div`
  text-align: center;
`;

const Map = styled.iframe`
  border: 2px solid white;
  width: 30em;
  height: 20em;
  max-width: 100%;
`;
*/

/**
 * Information section
 */
class Information extends PureComponent {
  render() {
    const { game, gameId } = this.props;

    return (
      <Container>
        <Heading>INFORMATION</Heading>
        <SubHeading>
          <Translate id="landingPage.information.subtitle" />
        </SubHeading>
        {!game && <Indicator spin />}
        {game && (
          <>
            <Table>
              <tbody>
                <tr>
                  <th>
                    <FaHistory size="1.2em" />
                    <Translate id="landingPage.information.playTime" />
                  </th>
                  <td>{game.gameDuration}</td>
                </tr>
                <tr>
                  <th>
                    <FaUser size="1.2em" />
                    <Translate id="landingPage.information.playerCapacity" />
                  </th>
                  <td>
                    <Translate id="landingPage.information.noPlayerLimit" />
                  </td>
                </tr>
                <tr>
                  <th>
                    <FaYenSign size="1.2em" />
                    <Translate id="landingPage.information.price" />
                  </th>
                  <td>
                    <span>
                      <Translate id="landingPage.information.weekday" /> &yen;
                      {formatCurrency(game.weekdayPrice)}
                    </span>
                    &nbsp;/&nbsp;
                    <span>
                      <Translate id="landingPage.information.holiday" /> &yen;
                      {formatCurrency(game.holidayPrice)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th>
                    <FaMobileAlt size="1.2em" />
                    <Translate id="landingPage.information.belongings.label" />
                  </th>
                  <td>
                    <Translate id="landingPage.information.belongings.value" />
                  </td>
                </tr>
                <tr>
                  <th>
                    <FaFortAwesome size="1.2em" />
                    <Translate id="landingPage.information.location.label" />
                  </th>
                  <td>
                    <div>
                      <Translate
                        id={`games.${gameId}.place`}
                        options={{ renderInnerHtml: true }}
                      />
                    </div>
                    <Warning>
                      <Translate id="landingPage.information.location.warning" />
                    </Warning>
                  </td>
                </tr>
              </tbody>
            </Table>
            {/* <MapContainer>
              <Map
                allowFullScreen=""
                frameBorder="0"
                loading="lazy"
                src={game.addressEmbedURL}
              />
            </MapContainer> */}
          </>
        )}
      </Container>
    );
  }
}

/**
 * Map Redux State to props
 */
const mapStateToProps = ({ global, firebase }) => {
  const gameId = global.gameId;
  return {
    gameId,
    game: getVal(firebase.data, `games/${gameId}`),
    databaseLoaded: global.loadedResources.database
  };
};

export default compose(
  connect(mapStateToProps, null),
  firebaseConnect(({ gameId, databaseLoaded }) => {
    // Check for database loaded
    if (!databaseLoaded) {
      return;
    }
    return [`games/${gameId}`];
  })
)(Information);
